import React, { Component } from "react";
import { FlexBox } from "js/react/components/LayoutGrid";
import { Icon, IconButton, InputAdornment, TextField } from "@material-ui/core";
import { Profile } from "js/react/components/Avatar";
import styled from "styled-components";
import { Gap10, Gap30 } from "js/react/components/Gap";
import { themeColors } from "js/react/sharedStyles";

const SelectableProfile = styled.div`
  padding: 10px;
  width: 100%;
  &:hover {
    background: ${themeColors.lightBlue};
   }
`;

const NoMatch = styled.div`
  font-style: italic;
  color: #666;
`;

const FilterInput = styled(TextField)`
  .MuiOutlinedInput-adornedEnd {
    padding-right: 8px;
  }
  .MuiIcon-root {
    opacity: 0.33;
    cursor: pointer;
  }
`;

export class TeamMemberFilterableList extends Component {
    state = {
        filter: ""
    }

    handleChangeFilter = event => {
        this.setState({
            filter: event.target.value
        });
    }

    handleClearFilter = () => {
        this.setState({
            filter: ""
        });
    }

    render() {
        let { teamMembers, onSelectTeamMember, maxHeight, placeholder } = this.props;
        let { filter } = this.state;

        let filteredMembers = teamMembers.filter(member => {
            return filter != "" && (member.displayName?.contains(filter) || member.email?.contains(filter));
        });

        return (
            <FlexBox vertical left top fill>
                <FilterInput
                    id="filter"
                    fullWidth
                    value={filter}
                    onChange={this.handleChangeFilter}
                    variant="outlined"
                    placeholder={placeholder}
                    autoFocus
                    autoComplete="off"
                    InputProps ={{
                        endAdornment: (
                            <InputAdornment>
                                <Icon onClick={this.handleClearFilter}>close</Icon>
                            </InputAdornment>
                        )
                    }}
                />

                <Gap10/>

                { filter != "" && filteredMembers.length == 0 && <NoMatch>No team members found that match</NoMatch> }

                <FlexBox vertical left fillWidth top style={{ maxHeight, overflowY: "scroll" }}>
                    { filteredMembers.map(member =>
                        (<SelectableProfile onClick={() => onSelectTeamMember(member)}>
                            <Profile profile={member}/>
                        </SelectableProfile>)
                    )}
                </FlexBox>
            </FlexBox>
        );
    }
}
